import { Expose } from "class-transformer";
import { IsArray, IsDefined, IsUUID } from "class-validator";
import { Column, ObjectIdColumn } from "typeorm";
import { v4 as uuid } from "uuid";

import type { ChangeLogItem } from "./ChangeLogItem";

export class ChangeLogs {
    @ObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @Column()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public ownerId: string;

    @Column()
    @IsArray()
    @IsDefined()
    @Expose()
    public logs: Array<ChangeLogItem> = [];
}
